import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getWrapperClasses = (cmp) => {
  const classes = [
    "relative",
    "flex",
    "flex-col",
    "gap-8",
    "rounded-m",
    "items-center",
    "text-center",
    "border",
    "border-dashed",
    "dsf-p-l",
    "block"
  ];
  if (cmp.dsf_error_message) {
    classes.push("border-error-300");
  } else {
    classes.push("border-neutral-200");
  }
  if (cmp.disabled) {
    classes.push("bg-neutral-50", "text-neutral-300");
  }
  return concatClasses(classes);
};
const getTitleClasses = (cmp) => {
  const classes = ["dsf-text-xs-semibold"];
  if (cmp.disabled) {
    classes.push("text-neutral-300");
  } else {
    classes.push("text-neutral-700");
  }
  return concatClasses(classes);
};
const getDescriptionClasses = (cmp) => {
  const classes = ["dsf-text-xxs"];
  if (cmp.disabled) {
    classes.push("text-neutral-300");
  } else {
    classes.push("text-neutral-400");
  }
  return concatClasses(classes);
};
const getDropzoneClasses = () => {
  const classes = [
    "flex",
    "items-center",
    "justify-center",
    "h-full",
    "w-full",
    "absolute",
    "top-0",
    "left-0",
    "right-0",
    "bottom-0",
    "bg-secondary-50"
  ];
  return concatClasses(classes);
};
export {
  getDescriptionClasses,
  getDropzoneClasses,
  getTitleClasses,
  getWrapperClasses
};
